import api from '../services/axios.service';

export async function fetchAllServices() {
    return api.get('services/all');
}

export async function switchService(serviceId) {
    return api.put(`services/switch?id=${serviceId}`);
}

export async function fetchApiTokensForAllServices() {
    return api.get('auth/client-credentials');
}

export async function createApiTokenForService({ serviceId, roleIds = [], description = '' }) {
    const payload = {
        description,
        service_id: serviceId,
        role_ids: roleIds
    };

    return api.post('auth/client-credentials', payload);
}

export async function deleteApiTokenForService(clientId) {
    return api.delete(`auth/client-credentials/${clientId}`);
}
